export var EnumArkMessages;
(function (EnumArkMessages) {
  EnumArkMessages["END_PREROLL"] = "arkadium:endPreroll";
  EnumArkMessages["SET_GAME_TYPE"] = "arkadium:setGameType";
})(EnumArkMessages || (EnumArkMessages = {}));